import { useEffect, useState } from 'react';
import { Box, Center, Column, Icon, Pressable, Text } from '~/commonComponents';
import { IPostingEntity } from '../../../domain/Postings';
import { Colors } from '../../../themes/colors';
import ConfirmPopup from '../../shared/ConfirmPopup';

const WarningIconComponent = () => (
  <Box marginBottom={12}>
    <Icon name="warning-outline" size={80} color={Colors.warning_500} />
  </Box>
);

interface IPaymentFailedPopupProps {
  isOpen: boolean;
  failedPostings: IPostingEntity[];
  totalCount: number;
  onRetry: () => void;
  onPayLater: () => void;
}

export const PaymentFailedPopup = ({
  isOpen,
  failedPostings,
  totalCount,
  onRetry,
  onPayLater,
}: IPaymentFailedPopupProps) => {
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setShowAll(false);
    }
  }, [isOpen]);

  if (!isOpen || failedPostings.length === 0) {
    return null;
  }

  const hasMore = failedPostings.length > 3;
  const initialPostings = failedPostings.slice(0, 3);

  const renderDescription = () => {
    return (
      <Center
        style={{
          width: '80%',
          marginBottom: -32,
        }}
      >
        <Column>
          <Text color="neutral_500" fontSize={16} marginBottom={16}>
            Your payment couldn&apos;t be processed, the following [{totalCount}] jobs remain
            suspended. Please try a different payment method.
          </Text>

          {!showAll ? (
            <>
              <Box gap={4} width={420}>
                {initialPostings.map((posting) => (
                  <Text
                    key={posting.id}
                    color="neutral_500"
                    fontSize={16}
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    • {posting.title}
                  </Text>
                ))}
              </Box>

              {hasMore && (
                <Box marginBottom={8} alignItems="flex-end">
                  <Pressable onPress={() => setShowAll(true)}>
                    <Text
                      color="secondary_500"
                      fontSize={16}
                      bold
                      style={{ textDecoration: 'underline' }}
                    >
                      View More
                    </Text>
                  </Pressable>
                </Box>
              )}
            </>
          ) : (
            <Box
              style={{
                maxHeight: 96,
                overflowY: 'auto',
              }}
              gap={4}
              paddingRight={8}
              marginBottom={8}
              width={420}
            >
              {failedPostings.map((posting) => (
                <Text
                  key={posting.id}
                  color="neutral_500"
                  fontSize={16}
                  style={{
                    overflow: 'clip',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  • {posting.title}
                </Text>
              ))}
            </Box>
          )}

          <Text color="neutral_500" fontSize={16} marginTop={16} textAlign="center">
            For help, call or text our Customer Service team at (855) 879-4688.
          </Text>
        </Column>
      </Center>
    );
  };

  return (
    //@ts-expect-error missing some props from ConfirmPopup
    <ConfirmPopup
      title="Payment Failed"
      description={renderDescription}
      Icon={WarningIconComponent}
      leftButtonText="Pay Later"
      rightButtonText="Try Again"
      leftButtonAction={onPayLater}
      rightButtonAction={onRetry}
      closePopup={onPayLater}
      dismissiblePopup={false}
      showClosePopupIcon={false}
    />
  );
};
